export default {"src":"/_next/static/media/DemystLogoWhite.51bb8a67.svg","height":40,"width":162};